import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=7d05a200&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d05a200')) {
      api.createRecord('7d05a200', component.options)
    } else {
      api.reload('7d05a200', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=7d05a200&", function () {
      api.rerender('7d05a200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tt0K076N0Toz/JS/CurrentYear.vue"
export default component.exports